import React from 'react'
import './Achievements.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode } from '@fortawesome/free-solid-svg-icons';

function Achievements() {
  return (
    <>

      <section id="Achievements" class="services">
        <div class="container">

          <div class="section-title">
            <div className="header-text-h1">
              <h1 className='header-text'>Achievements</h1>
            </div>
            <br />
            <br />
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="500">
              <div class="icon"><FontAwesomeIcon icon={faCode} bounce style={{ color: "#161717", }} size="xl" /></div>
              <h4 class="title"><a href="https://leetcode.com/dharmeshkporiya/">Solved 850+ DSA Problems</a></h4>
              <p class="description">I have solved 850+ dsa problems on leetcode.</p>
            </div>
            <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="500">
              <div class="icon"><FontAwesomeIcon icon={faCode} bounce style={{ color: "#161717", }} size="xl" /></div>
              {/* <i class="bi bi-code"></i> */}
              <h4 class="title"><a href="https://leetcode.com/dharmeshkporiya/">Badges Earned on Leetcode</a></h4>
              <p class="description">I have earned 25+ badges on leetcode which contain 365 days of badge and also monthly badges.</p>
            </div>

            <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="500">
              <div class="icon"><FontAwesomeIcon icon={faCode} bounce style={{ color: "#161717", }} size="xl" /></div>
              {/* <i class="bi bi-code"></i> */}
              <h4 class="title"><a href="https://leetcode.com/dharmeshkporiya/">Daily Coding streak on Leetcode</a></h4>
              <p class="description">Maintaining a streak of 690+ days on LeetCode has been a motivating factor for me to solve problems daily.</p>
            </div>

            <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="500">
              <div class="icon"><FontAwesomeIcon icon={faCode} bounce style={{ color: "#161717", }} size="xl" /></div>
              <h4 class="title"><a href="https://leetcode.com/dharmeshkporiya/">Contest ratings on Leetcode</a></h4>
              <p class="description">1683 is Current Rating (1683 max rating)</p>
            </div>

            <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up">
              <div class="icon"><FontAwesomeIcon icon={faCode} bounce style={{ color: "#161717", }} size="xl" /></div>
              <h4 class="title"><a href="#hacktoberfest">Hactoberfest</a></h4>
              <p class="description">I have completed 2022 Hactoberfest challenge with 5 merged Prs. And Received Hactoberfest Swags</p>
            </div>

            <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="500">
              <div class="icon"><FontAwesomeIcon icon={faCode} bounce style={{ color: "#161717", }} size="xl" /></div>
              <h4 class="title"><a href="https://auth.geeksforgeeks.org/user/dharmeshkporiya/practice">GFG POTD</a></h4>
              <p class="description">Solved 100+ daily problems on gfg and received Swags.</p>
            </div>

            <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="500">
              <div class="icon"><FontAwesomeIcon icon={faCode} bounce style={{ color: "#161717", }} size="xl" /></div>
              <h4 class="title"><a href="https://codeforces.com/profile/dharmesh.poriya07">Contest ratings on Codeforces</a></h4>
              <p class="description">976 is Current Rating (976 max rating)</p>
            </div>

            <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="500">
              <div class="icon"><FontAwesomeIcon icon={faCode} bounce style={{ color: "#161717", }} size="xl" /></div>
              <h4 class="title"><a href="https://replit.com/">HackStack'22 Hackathon</a></h4>
              <p class="description">Participated in HackStack'22 Hackathon & We were among in the top 10 Teams. <a href="https://devfolio.co/projects/rentaround-bb46">Project Link</a></p>
            </div>
            
            <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="500">
              <div class="icon"><FontAwesomeIcon icon={faCode} bounce style={{ color: "#161717", }} size="xl" /></div>
              <h4 class="title"><a href="https://www.codechef.com/users/d_poriya_07">Contest ratings on Codechef</a></h4>
              <p class="description">1506 is Current Rating (1559 max rating)</p>
            </div>



          </div>

        </div>
      </section>
    </>
  )
}

export default Achievements